let token = localStorage.getItem('token');
if(!token)
{
    token = crypto.randomUUID();
    localStorage.setItem('token', token);
}
document.getElementById('token').value = token;
